import { render, staticRenderFns } from "./AddRemoveCharacter.vue?vue&type=template&id=0c7d3d04&"
import script from "./AddRemoveCharacter.vue?vue&type=script&lang=js&"
export * from "./AddRemoveCharacter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports